import * as Sentry from '@sentry/react';
import { createBrowserRouter } from 'react-router-dom';
import { getAppConfig } from '@/config/apps';
import { env } from '@/lib/env';

const appConfig = getAppConfig(env.VITE_APP_ID);
const routes = appConfig.getRoutes();

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);
export const router = sentryCreateBrowserRouter(routes);
